export const CLASS_NAMES = {
    CONTAINER: "js-nav",
    ITEM: "js-navItem",
    LIST: "js-navList"
};
